module.exports = __webpack_public_path__ + "guide-integration01.5596a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/_asset/sources/assets/images/@svg/guide-integration01.svg
// module id = ./src/_asset/sources/assets/images/@svg/guide-integration01.svg
// module chunks = main